'use client';

import { SvgClock, SvgDelete } from '@common/icon';
import useEmblaCarousel from 'embla-carousel-react';
import type { MouseEvent } from 'react';

interface RecentSearchChipsProps {
  keywords: string[];
  onSelect: (keyword: string) => void;
  onRemove: (keyword: string) => void;
  onClearAll: () => void;
}

export function RecentSearchChips({
  keywords,
  onSelect,
  onRemove,
  onClearAll,
}: RecentSearchChipsProps) {
  const [emblaRef] = useEmblaCarousel({
    axis: 'x',
    align: 'start',
    dragFree: true,
    containScroll: 'trimSnaps',
  });

  if (keywords.length === 0) return null;

  const handleRemove = (e: MouseEvent, keyword: string) => {
    e.stopPropagation();
    onRemove(keyword);
  };

  return (
    <div className="flex h-auto w-full max-w-[850px] items-center gap-16 px-8 mobile-tablet:max-w-full mobile-tablet:border-b mobile-tablet:border-Gray-200 mobile-tablet:px-20 mobile-tablet:py-6">
      <div className="flex shrink-0 items-center gap-4">
        <SvgClock className="size-16 text-Gray-600" />
        <span className="text-Gray-600 typo-caption1">최근 검색어</span>
      </div>

      <div ref={emblaRef} className="min-w-0 flex-1 overflow-hidden">
        <div className="flex items-center gap-4">
          {keywords.map((keyword) => (
            <div
              key={keyword}
              role="button"
              tabIndex={0}
              className="flex h-28 shrink-0 cursor-pointer items-center gap-4 rounded-xsmall bg-Gray-100 p-8"
              onClick={() => onSelect(keyword)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') onSelect(keyword);
              }}
            >
              <span className="text-Gray-800 typo-caption1">{keyword}</span>
              <button
                type="button"
                aria-label={`${keyword} 삭제`}
                className="-m-4 size-16 p-4 flex-center"
                onClick={(e) => handleRemove(e, keyword)}
              >
                <SvgDelete className="size-8 text-Gray-600" />
              </button>
            </div>
          ))}
        </div>
      </div>

      <button
        type="button"
        className="shrink-0 text-Gray-600 typo-caption1 mobile-tablet:hidden"
        onClick={onClearAll}
      >
        전체 삭제
      </button>
    </div>
  );
}
